import React, {useEffect, useState} from "react";
import {
  Media,
  Form,
  Input,
  Textarea,
  Fields,
} from "../../components/Form/Form";
import {useNavigate, useParams} from "react-router-dom";
import useLocationHistoryService from "../../api/services/useLocationHistoryService";
import useStandService from "../../api/services/useStandService";
import Location from "../../components/Form/Location";
import useForm from "../../hooks/useForm";
import FeedbackPopup from "../../components/FeedbackPopup/FeedbackPopup";
import Button from "../../components/Button/Button";


const UserStandLocationHistoryEdit = () => {

  const {standId, id} = useParams()
  const locationHistoryService = useLocationHistoryService(standId)
  const {userShow: standShow} = useStandService()
  const navigate = useNavigate()
  const form = useForm()
  const [stand, setStand] = useState(null)

  const isNew = !id || id === 'new'

  useEffect(() => {
    standShow((data) => setStand(data), () => {}, standId)
  }, [standId])

  return (
    <div className="page-user-stand-location-history-edit">
      <div className="row">
        <div className="col">
          <h1>{isNew ? 'Plek toevoegen' : 'Plek bewerken'}</h1>
          <div className="row buttons">
            <Button label="Alle plekken" link={'/user/stand/' + standId + '/locaties'}/>
            {stand && stand.slug &&
              <Button label="Bekijk profiel" link={'/stand/' + stand.slug}/>
            }
          </div>
        </div>
        <div className="col col-feedback">
          <FeedbackPopup location={'/user/stand/' + standId + '/locaties/edit'}/>
        </div>
      </div>
      <Form>
        <Fields
          id={isNew ? null : id}
          initData={isNew ? {label: '', city: '', description: '', date_from: '', date_to: '', lat: null, lng: null} : null}
          form={form}
          apiService={locationHistoryService}
          updateSuccess={() => navigate('/user/stand/' + standId + '/locaties')}
          showDelete={!isNew}
          deleteLabel="Hiermee verwijder je deze plek:"
          deleteSuccess={() => navigate('/user/stand/' + standId + '/locaties')}
        >
          <Input
            label="Locatie naam"
            name="label"
            placeholder="Bijv. Weekmarkt Amsterdam"
          />
          <Input
            label="Stad"
            name="city"
            placeholder="Bijv. Amsterdam"
          />
          <Textarea
            label="Beschrijving"
            name="description"
            placeholder="Optionele beschrijving"
            rows={3}
          />
          <Input
            label="Van datum"
            name="date_from"
            type="date"
          />
          <Input
            label="Tot datum"
            name="date_to"
            type="date"
          />
          <Location
            label="Klik op de kaart om de locatie aan te geven waar je hebt gestaan."
          />
          <Media
            label="Foto"
            name="media"
            width={900}
            height={450}
            size="normal"
          />
        </Fields>
      </Form>
    </div>
  )
}

export default UserStandLocationHistoryEdit
